import { useLocation } from 'react-router';
import qs from 'qs';

function useQuery() {
  return qs.parse(useLocation().search, {
    ignoreQueryPrefix: true,
  });
}

export default useQuery;
